// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__3LQbK","contained":"OpenButton_contained__22lJm","disabled":"OpenButton_disabled__24fYE","error":"OpenButton_error__2seeg"};